import { ModelBase } from '../../core/model/model-base';
import { AccountType, AccountFunction, AccountFunctionToString, AccountTypeToString } from './const/enum';

export class Account extends ModelBase {
  constructor() {
    super();
  }

  get displayName(): string {
    return this.toString();
  }
  function: AccountFunction;
  get functionCaption(): string {
    return AccountFunctionToString(this.function);
  }
  name: string;
  number: string;
  type: AccountType;
  get typeCaption(): string {
    return AccountTypeToString(this.type);
  }

  toString(): string {
    return `${this.number} ${this.name}`;
  }
}
